import { UserType } from "entities/users/types";
import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";
import {
  useHits,
  useConfigure,
  useSearchBox,
  useInstantSearch,
} from "react-instantsearch";

const initialPaginationModal = {
  pageSize: 25,
  page: 0,
};

export const useUsersData = () => {
  const [paginationModel, setPaginationModel] = useState(
    initialPaginationModal,
  );
  const { query, refine: refineSearch, clear } = useSearchBox();
  const { hits, results } = useHits<UserType>();
  const { status } = useInstantSearch();

  // Clear search query on unmount custom hook
  useEffect(() => {
    return () => {
      clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResetPage = () =>
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

  // Use useConfigure to apply dynamic filters and pagination
  useConfigure({
    query,
    hitsPerPage: paginationModel.pageSize,
    page: paginationModel.page,
    filters: "isTelegramUser:true",
  });

  // Normalized table list data
  const data = useMemo(
    () =>
      hits.map((hit) => ({
        ...hit,
        id: hit.objectID,
        firstName: hit.firstName,
      })),
    [hits],
  );

  const onSearch = debounce((value) => {
    refineSearch(value);
    onResetPage();
  }, 500);

  const { nbHits = 0 } = results || {};
  const isLoading = status === "loading";

  return {
    searchData: {
      value: query,
      onChange: onSearch,
    },
    tableData: {
      data,
      rowCount: nbHits,
      paginationModel: paginationModel,
      onPaginationModelChange: setPaginationModel,
    },
    isLoading,
    onResetPage,
  };
};
